import { base } from '../base';

export const facebookAuth = `${base}/facebookAuth`;
